export default {
    common: {
        title: 'Editar imagen',
        cancel: 'Cancelar',
        save: 'Guardar',
        crop: 'Cosecha',
        adjustments: 'Ajustes',
        filters: 'Filtros',
        frames: 'Marcos',
        overlays: 'superposiciones',
        text: 'Texto',
        stickers: 'Pegatinas',
        brush: 'Cepillo',
        ai: 'Crear imagen utilizando IA',
        reset: 'Restablecer',
        comingSoon: 'Próximamente...',
        apply: 'Aplicar',
        undo: 'Deshacer',
        redo: 'Rehacer',
        flipHorizontal: 'Voltear horizontalmente',
        flipVertical: 'Voltear verticalmente',
        rotateClockwise: 'Rotar en sentido horario',
        rotateAntiClockwise: 'Girar en sentido contrario a las agujas del reloj',
        warning: 'Advertencia',
        discard: 'Descartar',
        continue: 'Continuar editando',
        discardHeading: '¿Descartar los cambios?',
        discardSubHeading: 'Si cierras el editor de imágenes, tus cambios no se guardarán',
        subtitle: 'Los formatos de imagen admitidos son PNG y JPEG',
        clone: 'Clonar',
        delete: 'Eliminar',
    },
};
